import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import {Observable, Subject} from 'rxjs';
import {
	HeaderFilterData,
	ProductMappingGridDataReturnModel,
	ProductMappingGridModel,
	ProductMappingModel,
	ProductMappingToMasterGridResult,
	ProductMasterWithSizeListGrid,
	ProductMasterWithSizeListGridDataReturnModel,
	ServiceMasterGridResult,
	UnifiedTransactionsForServiceAndProductMappingResult,
	UnifiedTransactionsForServiceAndProductMappingReturn
} from '../shared/models/product.model';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';
import { BarcodeMappingOption } from '../shared/models/product-mapping-option';
import {
	InconsistentServiceAndProductMappingForProductBarcodeAssignmentModelResult,
	ProcessingStatusForServiceAndProductMappingResult
} from '../shared/models/product-barcode.model';

@Injectable({providedIn: 'root'})
export class ProductMappingService {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

	private url = Constants.devServerEndpoint + 'api/productmapping';
	private tempUrl = 'http://localhost:6509/api/productmapping';

	constructor(private httpClient: HttpClient) { }

	public getProductMappingToMasterGridResult(serviceAndProductMappingId: number): Observable<ProductMappingToMasterGridResult[]> {
		return this.httpClient.get<ProductMappingToMasterGridResult[]>(this.url + `/getProducMappingToMasterGridResult/${serviceAndProductMappingId}`, { headers: this.headers });
	}

	public getUnifiedTransactionsForServiceAndProductMapping(param: LoadOptions, serviceAndProductMappingId: number): Observable<UnifiedTransactionsForServiceAndProductMappingReturn[]> {
		return this.httpClient
			.post<UnifiedTransactionsForServiceAndProductMappingReturn[]>(
				this.url + `/getUnifiedTransactionsForServiceAndProductMapping/${serviceAndProductMappingId}`, {param, serviceAndProductMappingId},
				{ headers: this.headers }
			);
	}

	public getProductMasterWithSizeListGrid(param: LoadOptions): Observable<ProductMasterWithSizeListGridDataReturnModel> {
		return this.httpClient
			.post<ProductMasterWithSizeListGridDataReturnModel>(
				this.url + `/getProductMasterWithSizeListGrid`, param,
				{ headers: this.headers }
			);
	}

	public getProductMasterWithSearchSizeListGrid(param: LoadOptions): Observable<ProductMasterWithSizeListGridDataReturnModel> {
		return this.httpClient
			.post<ProductMasterWithSizeListGridDataReturnModel>(
				this.url + `/getProductMasterWithSearchSizeListGrid`, param,
				{ headers: this.headers }
			);
	}

	public getProductMappingGrid(param: LoadOptions): Observable<ProductMappingGridDataReturnModel> {
		return this.httpClient
			.post<ProductMappingGridDataReturnModel>(
				this.url + `/getProductMapping`, param,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersProductMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersProductMaster`, param,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersProductMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersProductMapping`, param,
				{ headers: this.headers }
			);
	}

	public mappingAction(productMappingOption): Observable<any> {
		return this.httpClient
			.post<any>(
				this.url + '/mappingAction', productMappingOption,
				{ headers: this.headers }
			);
	}

	public createOrModifyBarcode(data: BarcodeMappingOption): Observable<any> {
		return this.httpClient
			.post(
				this.url + '/createOrModifyBarcode', data,
				{ headers: this.headers }
			);
	}

	public getProcessingStatusForServiceAndProductMapping(param: LoadOptions, serviceAndProductMappingId: number): Observable<ProcessingStatusForServiceAndProductMappingResult[]> {
		return this.httpClient.post<ProcessingStatusForServiceAndProductMappingResult[]>(this.url + `/getProcessingStatusForServiceAndProductMapping`, {param, serviceAndProductMappingId}, { headers: this.headers });
	}
}
